import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import ADGMImage from '../ADGMImage';
import styles from './adgm-alert-jss';

function getIcon(type) {
  switch (type) {
    case 'success':
      return 'success.svg';
    case 'error':
      return 'ErrorOrange.svg';
    case 'warning':
      return 'warning_dark_orange.svg';
    case 'mute':
      return 'InformationDarkGrey.svg';
    default:
      return 'Information.svg';
  }
}

function ADGMAlert(props) {
  const {
    classes,
    children,
    type,
    visible,
    noBackground,
    smoothBorderRaduis,
    className,
    hideIcon,
    customClasses,
  } = props;

  return visible ? (
    <div
      className={classNames(
        classes.container,
        classes[type],
        {
          [classes.noBackground]: noBackground,
          [classes.background]: !noBackground,
          [classes.smoothBorderRaduis]: smoothBorderRaduis,
        },
        classes[className],
        className,
        customClasses?.container,
      )}
    >
      {!hideIcon && <ADGMImage name={getIcon(type)} alt='type' />}
      {children}
    </div>
  ) : null;
}

ADGMAlert.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  visible: PropTypes.bool,
  noBackground: PropTypes.bool,
  hideIcon: PropTypes.bool,
  customClasses: PropTypes.object,
  smoothBorderRaduis: PropTypes.bool,
};

ADGMAlert.defaultProps = {
  type: null,
  className: null,
  visible: true,
  noBackground: false,
  hideIcon: false,
  customClasses: {},
  smoothBorderRaduis: false,
};

export default React.memo(withStyles(styles)(ADGMAlert));
